import React from 'react';
import { Grid, Header, Divider } from 'semantic-ui-react';

import FNButtons from '../FNButtons';
import SelectField from './SelectField';

const PreSection = ({
  onSelectChange,
  onMultiSelectChange,
  onDateChange,
  showSubmit,
  onBack,
  onNext,
  onSubmit,
  options,
  fullOptionsData
}) => {
  if (!fullOptionsData) return null;

  const groups = {};
  fullOptionsData.groups.forEach(group => {
    groups[group.id] = { label: group.label, fields: [] };
  });

  fullOptionsData.options.forEach(({ group, ...option }) => {
    groups[group].fields.push({ ...option, selectValue: options[option.id] });
  });

  const groupsArray = Object.keys(groups).map(group => groups[group]);

  return (
    <React.Fragment>
      <Divider hidden />
      <Divider hidden />
      <Grid>
        {groupsArray.map(({ label, fields }) => (
          <React.Fragment key={label}>
            <Header size="medium">{label}</Header>
            <Grid.Row columns={3}>
              {fields.map(option => (
                <Grid.Column key={option.name}>
                  <SelectField
                    option={option}
                    onMultiSelectChange={onMultiSelectChange}
                    onSelectChange={onSelectChange}
                    onDateChange={onDateChange}
                  />
                  <br />
                </Grid.Column>
              ))}
            </Grid.Row>
          </React.Fragment>
        ))}
      </Grid>
      <FNButtons
        showSubmit={showSubmit}
        onBack={onBack}
        onNext={onNext}
        onSubmit={onSubmit}
      />
    </React.Fragment>
  );
};

export default PreSection;



// WEBPACK FOOTER //
// ./src/component/TaskCreator/PreSection/index.js